import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormFieldComponent} from './form-field.component';

import {TranslateModule} from "@ngx-translate/core";
import {ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {AngularSvgIconModule} from 'angular-svg-icon';

@NgModule({
  declarations: [
    FormFieldComponent

  ],
  exports: [
    FormFieldComponent
  ],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        AngularSvgIconModule
    ]
})
export class FormFieldModule { }
